<div class="mr-2">
    <p>{{ 'privacyPolicy.first-paragraph' | translate }}</p>
    <p>{{ 'privacyPolicy.second-paragraph' | translate }}</p>
    <p>{{ 'privacyPolicy.third-paragraph' | translate }}</p>
    <p>{{ 'privacyPolicy.fourth-paragraph' | translate }}</p>
    <p>{{ 'privacyPolicy.fifth-paragraph' | translate }}</p>
    <p>{{ 'privacyPolicy.sixth-paragraph' | translate }}</p>
</div>